export enum ChatType {
  GENERIC = 'generic',
  COMPANY = 'company',
  ASSISTANT = 'assistant',
}
